import gsap from "gsap";
import ScrollLock from "@bornfight/b-scroll-lock";

/**
 * NavigationMenu class
 */
export default class NavigationMenu {
    constructor() {
        /**
         *
         * @type {{image: string, navTabWrapper: string, openClass: string, activeClass: string, line: string, navItems: string, drawer: string, navTabContentWrapper: string, btn: string, triangle: string}}
         */
        this.defaults = {
            //elements
            navigation: ".js-navigation-wrapper",
            navItems: ".js-nav-main-item",
            mobileNavItems: ".js-mobile-nav-main-item",
            line: ".js-nav-line",
            btn: ".js-nav-btn",
            drawer: ".js-nav-drawer",
            triangle: ".js-nav-triangle",
            image: ".js-nav-image",
            navTabWrapper: ".js-nav-tab-wrapper",
            navTabContentWrapper: ".js-nav-tab-content-wrapper",
            navPartners: ".js-partners",

            //CSS state classes
            activeClass: "is-active",
            openClass: "is-opened",
            openClassFinished: "is-open-animation-finished",
        };

        this.isOpened = false;

        this.scrollLock = new ScrollLock();

        // Elements
        /**
         * Button elements
         * @type {Element}
         */
        this.btn = document.querySelector(this.defaults.btn);

        /**
         *
         * @type {Element}
         */
        this.navigation = document.querySelector(this.defaults.navigation);
    }

    //region methods

    init() {
        console.log("Navigation init()");

        if (this.btn == null) {
            return;
        }

        this.timelineInit();
        this.btnController();

        document.querySelectorAll(".menu .menu-item-has-children > a").forEach
            (el => { 
                el.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                this.parentNode.classList.toggle('active');
                this.querySelector("submenu-content").classList.add('active');          
            });
        });

        // nav hero saleforce template
        const SaleforceActive = document.querySelector('.saleforce-active').value;
        const SubnavMobileActive = document.querySelector('.subnav-mobile-active').value;

        if (SaleforceActive ==  "yes") {
            const saleforceHeroLight=document.getElementsByClassName('js-navigation-wrapper')[0];
            saleforceHeroLight.classList.add('have-light-header');
        }


        if (SubnavMobileActive ==  "yes") {
            const navsaleforcemobile = document.querySelector('.nav-saleforce-mobile');
            if (typeof navsaleforcemobile !== 'undefined') {
                navsaleforcemobile.addEventListener('click', function (event) {
                this.parentNode.classList.toggle('active');
                this.classList.toggle('active');
                this.classList.toggle('is-opened');            
                })
            };    
        
        
           
        
        }        

 // Modules functio for
 document.querySelectorAll(".sop-columns").forEach((container) => {
    const itemNav = container.querySelectorAll(".item");
    const itemText = container.querySelectorAll(".item-text");

    itemNav.forEach((itemNavFor) => {
        itemNavFor.addEventListener('click', function () {
            var post_active = this.getAttribute('data-post');

            itemNav.forEach(x => x.classList.remove('active'));
            this.classList.toggle('active');

            itemText.forEach(x => x.classList.remove('active'));
            const itemActive = container.querySelector(".content_" + post_active);

            if (itemActive) {
                itemActive.classList.add('active');
                itemActive.classList.add('activeEPIC');
            }
        });
    });
});


        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                });
            });
        });

    }

    timelineInit() {
        this.timeline = gsap.timeline({
            paused: true,
        });

        this.timeline
            .add("start")
            .to(
                this.defaults.drawer,
                {
                    y: "0%",
                    duration: 1,
                    ease: "expo.out",
                },
                "start",
            )
            .to(
                this.defaults.line,
                {
                    scaleX: 0,
                    duration: 1,
                    delay: 0.1,
                    ease: "power4.inOut",
                },
                "start",
            )
            .add("nav-items", "-=0.5")
            .fromTo(
                this.defaults.navItems,
                {
                    autoAlpha: 0,
                    y: "20%",
                    skewY: "2.5deg",
                },
                {
                    autoAlpha: 1,
                    y: "0%",
                    skewY: "0deg",
                    stagger: 0.18,
                    duration: 0.4,
                },
                "nav-items",
            )
            .fromTo(
                this.defaults.mobileNavItems,
                {
                    autoAlpha: 0,
                    y: "20%",
                    skewY: "2.5deg",
                },
                {
                    autoAlpha: 1,
                    y: "0%",
                    skewY: "0deg",
                    stagger: 0.18,
                    duration: 0.4,
                },
                "nav-items",
            )
            .add("drawer-tabs", "-=0.65")
            .fromTo(
                this.defaults.navTabWrapper,
                {
                    autoAlpha: 0,
                    y: "10%",
                    skewY: "2.5deg",
                },
                {
                    autoAlpha: 1,
                    y: "0%",
                    skewY: "0deg",
                    duration: 0.2,
                },
                "drawer-tabs",
            )
            .fromTo(
                this.defaults.navTabContentWrapper,
                {
                    autoAlpha: 0,
                    y: "10%",
                    skewY: "2.5deg",
                },
                {
                    autoAlpha: 1,
                    y: "0%",
                    skewY: "0deg",
                    duration: 0.2,
                    delay: 0.15,
                },
                "drawer-tabs",
            )
            .to(
                this.defaults.navPartners,
                {
                    autoAlpha: 1,
                    duration: 0.2,
                    delay: 0.15,
                },
                "drawer-tabs",
            )
            .add("triangles", "-=0.4")
            .to(
                this.defaults.triangle,
                {
                    autoAlpha: 1,
                    duration: 0.4,
                    ease: "power4.inOut",
                },
                "triangles",
            )
            .to(
                this.defaults.image,
                {
                    autoAlpha: 1,
                    duration: 0.45,
                    ease: "power4.inOut",
                },
                "triangles",
            );
    }

    btnController() {
        this.btn.addEventListener("click", () => {
            if (this.isOpened === false) {
                this.isOpened = true;
                this.openNav();
                return;
            }

            this.isOpened = false;
            this.closeNav();
        });
    }

    openNav() {
        this.navigation.classList.add(this.defaults.openClass);
        this.btn.classList.add(this.defaults.openClass);
        this.timeline
            .timeScale(1)
            .play()
            .eventCallback("onComplete", () => {
                this.navigation.classList.add(this.defaults.openClassFinished);
                this.scrollLock.lockScroll();
            });
    }

    closeNav() {
        this.scrollLock.unlockScroll();
        this.btn.classList.remove(this.defaults.openClass);
        this.navigation.classList.remove(this.defaults.openClassFinished);
        this.timeline
            .timeScale(2)
            .play()
            .reverse()
            .eventCallback("onReverseComplete", () => {
                this.navigation.classList.remove(this.defaults.openClass);
            });
    }

    //endregion
}
